import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { debounce } from 'lodash';
import { ILink } from '../../components/skip-link/skip-link.interface';
import { INavBarAccessibilityContent, INavBarConfigContent, ITranslateNavBarConfig, NavBarType } from '../responsive-nav-bar/nav-bar.interface';
import { ResponsiveLayoutService } from './responsive-layout-service';
import { TLang } from '../../../family-connectors-portal/src/app/constants/supported-languages';

@Component({
  selector: 'responsive-layout',
  templateUrl: './responsive-layout.component.html',
  styleUrls: ['./responsive-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ResponsiveLayoutComponent {
  @Input() navAriaLabels: INavBarAccessibilityContent;
  @Input() hideNav: boolean = false;
  @Input() skipLinkContent: ILink[];
  @Input() navConfigs: INavBarConfigContent;
  @Input() translateConfig: ITranslateNavBarConfig;
  @Input() navLogoType: string;
  @Output() navTypeChange = new EventEmitter<NavBarType>();
  @Output() switchLanguage = new EventEmitter<string>();

  constructor (
    public elementRef: ElementRef<HTMLElement>,
    private resLayoutService: ResponsiveLayoutService,
  ) {}

  @ViewChild('mainContent', { static: false }) mainContentElement: ElementRef;
  @ViewChild('footer', { static: false }) footerElement: ElementRef;
  public navType: NavBarType = NavBarType.SIDE_NAV;

  ngAfterViewInit () {
    this.onResize({ target: this.elementRef.nativeElement });
  }

  // TODO - tech debt - leverage isMobile service
  @HostListener('window:resize', ['$event'])
    onResize = debounce($event => {
      const isSmallViewport = this.resLayoutService.isSmallViewportWidth($event.target);
      if (isSmallViewport) {
        this.navType = NavBarType.TOP_NAV_CLOSED;
      } else {
        this.navType = NavBarType.SIDE_NAV;
      }
      this.navTypeChange.emit(this.navType);
    }, 20);

  public changeNavType ($event: { action: 'closeTopNavMenu' | 'openTopNavMenu' }) {
    const { action } = $event;
    if (action === 'openTopNavMenu') {
      this.navType = NavBarType.TOP_NAV_OPENED;
    }
    if (action === 'closeTopNavMenu') {
      this.navType = NavBarType.TOP_NAV_CLOSED;
    }
    this.navTypeChange.emit(this.navType);
  }

  public skipFocusTo (target: string): void {
    switch (target) {
      case 'mainContent':
        this.skipFocusToMainContent();
        break;
      case 'footer':
        this.skipFocusToFooter();
        break;
      default:
        break;
    }
  }

  public skipFocusToMainContent (): void {
    const mainContent = this.mainContentElement.nativeElement;
    if (mainContent) {
      mainContent.focus();
    }
  }

  public skipFocusToFooter (): void {
    const footer = this.footerElement.nativeElement;
    if (footer) {
      footer.focus();
    }
  }

  public onSwitchLanguage (lang: TLang): void {
    this.switchLanguage.emit(lang);
  }
}
